import { memo, ReactElement } from "react"

interface RenderIfProps {
	condition: boolean;
	children: ReactElement;
}

const RenderIf = ({ condition, children }: RenderIfProps) => {
	if (condition) {
		return children;
	} else {
		return <></>;
	}
}

export default memo(RenderIf);